export default __webpack_public_path__ + "static/media/team_04.10f10223.png";